import { Trigger } from '@radix-ui/react-popover';
import { ComponentPropsWithoutRef } from 'react';

type Props = ComponentPropsWithoutRef<typeof Trigger>;
export const PopoverTrigger = (props: Props) => {
    return <Trigger data-testid="popover-trigger" {...props} />;
};
